// Rexven'in urun rengine gore baski rengi onerisi (kullanici 2026-10-25, Rexven tablosu).
// Acik/koyu tasarim kararinda YZ tonundan ve piksel parlakligindan ONCE gelir:
// "white" = beyaz/acik murekkep -> acik tasarim; "black" -> koyu tasarim; "both" = ikisi de olur
// (karar YZ/parlakliga kalir). Tabloda olmayan renk -> null.
//
// Bilerek ALINMAYANLAR: tisort BLACK -> "SIYAH" (siyah tisorte siyah baski; sweatshirt/hoodie'de
// BEYAZ — tablo hatasi sayildi, beyaz yazildi). Comfort Colors sutunu (Butter, Chalky Mint, Ice Blue
// gibi acik renklere WHITE diyor) kullanici dogrulayana kadar uygulanmaz.

export type RexvenInk = "white" | "black" | "both";
type Line = "tshirt" | "sweatshirt" | "hoodie";

const W = "white", B = "black", X = "both";
const SWEAT: Record<string, RexvenInk> = {
  "ATH GRAY": B, RED: X, SAND: B, PURPLE: W, ORANGE: X, "LIGHT PINK": B, "LIGHT BLUE": B,
  "IRISH GREEN": W, MGREEN: W, MAROON: W, WHITE: B, BLACK: W, "DARK GRAY HTR": W, GOLD: B,
};
const TABLE: Record<Line, Record<string, RexvenInk>> = {
  tshirt: {
    "IRISH GREEN": W, WHITE: B, PINK: B, "HTR TRUE ROYAL": W, "HTR RASPBERRY": W, "HTR PEACH": B,
    "HTR OLIVE": W, "HTR MAROON": W, "DARK GRAY HTR": W, BLACK: W, "ATH HTR": B, "HTR MAUVE": W,
    RED: X, "HTR DEEP TEAL": W, "HTR MIDNIGHT NAVY": W, ORANGE: X, MINT: B,
  },
  sweatshirt: SWEAT,
  hoodie: SWEAT,
};

/** Renk adini tablo bicimine getirir: HEATHER->HTR, ATHLETIC->ATH, GREY->GRAY, MILITARY GREEN->MGREEN */
export function normalizeRexvenColor(name: string): string {
  return name.toUpperCase()
    .replace(/[^A-Z ]+/g, " ")
    .replace(/\bHEATHER\b/g, "HTR").replace(/\bATHLETIC\b/g, "ATH").replace(/\bGREY\b/g, "GRAY")
    .replace(/\bMILITARY GREEN\b/g, "MGREEN").replace(/\bRASBERRY\b/g, "RASPBERRY")
    .replace(/\bDARK HTR\b/g, "DARK GRAY HTR").replace(/\bATH GRAY HTR\b/g, "ATH HTR")
    .replace(/\s+/g, " ").trim();
}

/** Marka/model metninden urun hatti (bilinmiyorsa null) */
export function rexvenLine(model?: string | null): Line | null {
  const m = (model ?? "").toLowerCase();
  if (/1717|comfort/.test(m)) return null; // Comfort Colors: dogrulanana kadar yok
  if (/18500|hoodie|kap[sş]onlu/.test(m)) return "hoodie";
  if (/18000|sweat/.test(m)) return "sweatshirt";
  if (/64000|5000|t-?shirt|tee|ti[sş][oö]rt/.test(m)) return "tshirt";
  return null;
}

/** Rexven onerisi. Hat bilinmiyorsa butun hatlarda aranir; hatlar celisirse null. */
export function rexvenInk(color: string | null | undefined, model?: string | null): RexvenInk | null {
  if (!color) return null;
  const k = normalizeRexvenColor(color);
  if (/1717|comfort/i.test(model ?? "")) return null;
  const line = rexvenLine(model);
  if (line) return TABLE[line][k] ?? null;
  const hits = new Set((Object.values(TABLE).map((t) => t[k]).filter(Boolean)) as RexvenInk[]);
  return hits.size === 1 ? [...hits][0] : null;
}

/** Alanin tasarim temasi ("light" = acik tasarim, koyu urune). Rexven kesin soyluyorsa o;
 *  yoksa kumas tonu (koyu urune acik tasarim, acik/orta urune koyu tasarim). */
export function designThemeFor(tone: "light" | "mid" | "dark", color?: string | null, model?: string | null): "light" | "dark" {
  const ink = rexvenInk(color, model);
  if (ink === "white") return "light";
  if (ink === "black") return "dark";
  return tone === "dark" ? "light" : "dark";
}
